import BenutzerDto from "../Benutzer/BenutzerDto";

export default class WeitergabeDto {

  constructor(json) {
    if (json) {
      this.id = json.id
      this.geschaeftspartnerName = json.geschaeftspartnerName
      this.austauschmenge = json.austauschmenge

      this.austauschdatum = json.austauschdatum
      this.erstelltVon = json.erstelltVon ? new BenutzerDto(json.erstelltVon) : null

      this.bestaetigungsdatum = json.bestaetigungsdatum
      this.bestaetigtVon = json.bestaetigtVon ? new BenutzerDto(json.bestaetigtVon) : null

      this.ablehnungsdatum = json.ablehnungsdatum
      this.abgelehntVon = json.abgelehntVon ? new BenutzerDto(json.abgelehntVon) : null

      this.isAnnahme = json.annahme === true || json.annahme === "true"
      this.status = 'weitergabe.status.' + json.status
      this.statusRaw = json.status
    }
  }

  get menge() {
    const prefix = this.isAnnahme ? '+' : '-'
    return prefix + this.austauschmenge
  }

  get art() {
    if (this.isAnnahme) {
      return 'weitergabe.art.annahme'
    } else {
      return 'weitergabe.art.weitergabe'
    }
  }
}
